declare namespace $ {

	type $mol_paragraph__title_bog_blitz_lobby_players_1 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_players['player_id'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_open_native__files_bog_blitz_lobby_players_2 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_players['player_avatar_files'] >
		,
		ReturnType< $mol_button_open_native['files'] >
	>
	type $mol_button_open_native__accept_bog_blitz_lobby_players_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open_native['accept'] >
	>
	type $mol_button_open_native__multiple_bog_blitz_lobby_players_4 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_button_open_native['multiple'] >
	>
	type $mol_row__attr_bog_blitz_lobby_players_5 = $mol_type_enforce<
		({ 
			'bog_blitz_mine': ReturnType< $bog_blitz_lobby_players['is_mine'] >,
		}) 
		,
		ReturnType< $mol_row['attr'] >
	>
	type $mol_row__sub_bog_blitz_lobby_players_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_avatar__id_bog_blitz_lobby_players_7 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_players['player_id'] >
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $mol_image__uri_bog_blitz_lobby_players_8 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_players['player_avatar_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_string_button__hint_bog_blitz_lobby_players_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_string_button__value_bog_blitz_lobby_players_10 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_players['player_name'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_players_11 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_players['player_name'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_open__sub_bog_blitz_lobby_players_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_open['sub'] >
	>
	export class $bog_blitz_lobby_players extends $mol_list {
		player_views( ): readonly(any)[]
		is_mine( id: any): boolean
		player_avatar_content( id: any): any
		player_id( id: any): string
		Player_id( id: any): $mol_paragraph
		player_name_content( id: any): any
		player_avatar_uri( id: any): string
		player_name( id: any): string
		player_avatar( id: any): any
		player_avatar_files( id: any, next?: readonly(File)[] ): readonly(File)[]
		Player_avatar_native( id: any): $mol_button_open_native
		players_dict( ): any
		my_lord_str( ): string
		rows( ): ReturnType< $bog_blitz_lobby_players['player_views'] >
		Player( id: any): $mol_row
		Player_icon( id: any): $mol_avatar
		Player_image( id: any): $mol_image
		Player_name_input( id: any): $mol_string_button
		Player_name_label( id: any): $mol_paragraph
		Player_avatar_button( id: any): $mol_button_open
	}
	
}

//# sourceMappingURL=players.view.tree.d.ts.map